import React, { useState } from 'react';
import CustomRadioButton from '../../../components/CustomRadioButton/CustomRadioButton';
import star from "../../../assets/star.svg"
import starLine from "../../../assets/star-line.svg"

const RatingRadioButton = ({ items }) => {
    const [selected, setSelected] = useState("");


    const getRatings = (rating) => {
        return <div className='rating-cont'>
            {Array.from({ length: Number(rating) }).map((_, index) => (
                <img key={index} src={star} alt="" />
            ))}
            {Array.from({ length: (5 - Number(rating)) }).map((_, index) => (
                <img key={index} src={starLine} alt="" />
            ))}
            {Number(rating) < 5 && <>& up</>}
        </div>
    }
    return (
        <>
            {
                items.map((item) => {
                    return (
                        <div className='RatingRadioContainer'>
                            <CustomRadioButton
                                label={getRatings(item.Star)}
                                value={item.Star}
                                checked={selected === item.Star}
                                onChange={(e) => setSelected(e.target.value)}
                            />
                            <div className="count-container">({item.Count})</div>
                        </div>
                    )
                })
            }



        </>
    );
}

export default RatingRadioButton;
